export var PULLING_STATUS_DELAY = 10000;
